<template>
  <div class="content-wrapper  solutions">
    <a href="#"/></a>

    <div class="b-solution-in">
      <breadcrumbs :items="breadcrumbs" />

      <h1 class="b-solution__name">Жилые помещения</h1>
      <div class="b-solution__dots">
        <v-img
          class="b-solution__img"
          src="upload/iblock/c98/c98b2161ab0c654739555363d005d2ec.jpg"
          alt=""
          :aspect-ratio="1.629"
        />
        <div data-id="1" class="b-solution__dot" style="top: 90%; left: 10%;">
          1
        </div>

        <div data-id="2" class="b-solution__dot" style="top: 85%; left: 18%;">
          2
        </div>

        <div data-id="3" class="b-solution__dot" style="top: 70%; left: 16%;">
          3
        </div>

        <div data-id="4" class="b-solution__dot" style="top: 82%; left: 55%;">
          4
        </div>

        <div data-id="5" class="b-solution__dot" style="top: 68%; left: 30%;">
          5
        </div>

        <div data-id="6" class="b-solution__dot" style="top: 19%; left: 73%;">
          6
        </div>
      </div>

      <div class="b-solution__groups">
        <div class="b-solution__group">
          <div class="b-solution__group-title" data-id="1">
            <div class="b-solution__group-key">1</div>
            -
            <div class="b-solution__group-name">Стяжка</div>
          </div>
          <div class="b-solution__group-desc">
            Выравнивание поверхности пола и создание уклонов
          </div>

          <div class="b-solution__group-items">
            <div class="b-solution__group-item">
              <div class="b-solution__group-item-img">
                <a
                  href="#"
                >
                  <img
                    src="https://sikahome.ru/upload/iblock/bc5/bc513b5310cf427f0453af997982fd89.jpg"
                    alt=""
                  />
                </a>
              </div>
              <div class="b-solution__group-item-text">
                <div class="b-solution__group-item-title">
                  <a
                    href="#"
                    >Sikafloor®-206 Screed</a
                  >
                </div>
                <div class="b-solution__group-item-desc">
                  Быстротвердеющая стяжка с толщиной нанесения до 60 мм
                </div>
              </div>
            </div>
            <div class="b-solution__group-item">
              <div class="b-solution__group-item-img">
                <a
                  href="#"
                >
                  <img
                    src="upload/iblock/c7f/c7f1ac79d5bca47a69e8a2cff1a9b60c.jpg"
                    alt=""
                  />
                </a>
              </div>
              <div class="b-solution__group-item-text">
                <div class="b-solution__group-item-title">
                  <a
                    href="#"
                    >Sikafloor®-258 Screed Fiber</a
                  >
                </div>
                <div class="b-solution__group-item-desc">
                  Армированная быстротвердеющая стяжка с толщиной нанесения до
                  80 мм
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="b-solution__group">
          <div class="b-solution__group-title" data-id="2">
            <div class="b-solution__group-key">2</div>
            -
            <div class="b-solution__group-name">Грунт</div>
          </div>
          <div class="b-solution__group-desc">Увеличение адгезии</div>

          <div class="b-solution__group-items">
            <div class="b-solution__group-item">
              <div class="b-solution__group-item-img">
                <a
                  href="#"
                >
                  <img
                    src="upload/iblock/56d/56dda1ee82932f6efdf7b84afbc1cb29.png"
                    alt=""
                  />
                </a>
              </div>
              <div class="b-solution__group-item-text">
                <div class="b-solution__group-item-title">
                  <a
                    href="#"
                    >Sikafloor®-06 Primer ExtraPro</a
                  >
                </div>
                <div class="b-solution__group-item-desc">
                  Водно-дисперсионный универсальный акриловый грунт
                </div>
              </div>
            </div>
            <div class="b-solution__group-item">
              <div class="b-solution__group-item-img">
                <a
                  href="#"
                >
                  <img
                    src="upload/iblock/3f3/3f3c893dfe490f78d2d8a26558428e6f.png"
                    alt=""
                  />
                </a>
              </div>
              <div class="b-solution__group-item-text">
                <div class="b-solution__group-item-title">
                  <a
                    href="#"
                    >Sikafloor®-07 Primer Pro</a
                  >
                </div>
                <div class="b-solution__group-item-desc">
                  Концентрат водно-дисперсионного универсального акрилового
                  грунта
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="b-solution__group">
          <div class="b-solution__group-title" data-id="3">
            <div class="b-solution__group-key">3</div>
            -
            <div class="b-solution__group-name">Наливной пол</div>
          </div>
          <div class="b-solution__group-desc">
            Финишное выравнивание поверхности пола
          </div>

          <div class="b-solution__group-items">
            <div class="b-solution__group-item">
              <div class="b-solution__group-item-img">
                <a
                  href="#"
                >
                  <img
                    src="https://sikahome.ru/upload/iblock/282/282aa06b2eb8559be6b9b86a992e67a7.jpg"
                    alt=""
                  />
                </a>
              </div>
              <div class="b-solution__group-item-text">
                <div class="b-solution__group-item-title">
                  <a
                    href="#"
                    >Sika® Level Universal</a
                  >
                </div>
                <div class="b-solution__group-item-desc">
                  Наливной пол с быстрым набором прочности для финишного
                  выравнивания от 2 до 20 мм
                </div>
              </div>
            </div>
            <div class="b-solution__group-item">
              <div class="b-solution__group-item-img">
                <a href="#">
                  <img
                    src="https://sikahome.ru/upload/iblock/8b5/8b5715f7cbf29f3b14c1148ec96b325b.jpg"
                    alt=""
                  />
                </a>
              </div>
              <div class="b-solution__group-item-text">
                <div class="b-solution__group-item-title">
                  <a href="#"
                    >Sika® Level Pro</a
                  >
                </div>
                <div class="b-solution__group-item-desc">
                  Высокопрочный быстротвердеющий наливной пол для финишного
                  выравнивания от 5 до 30 мм
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="b-solution__group">
          <div class="b-solution__group-title" data-id="4">
            <div class="b-solution__group-key">4</div>
            -
            <div class="b-solution__group-name">
              Клей для гибких напольных покрытий
            </div>
          </div>
          <div class="b-solution__group-desc">
            Приклеивание линолиума и ковролина
          </div>

          <div class="b-solution__group-items">
            <div class="b-solution__group-item">
              <div class="b-solution__group-item-img">
                <a
                  href="#"
                >
                  <img
                    src="upload/iblock/ab4/ab4483767bf5f2c329293e78242d215c.jpg"
                    alt=""
                  />
                </a>
              </div>
              <div class="b-solution__group-item-text">
                <div class="b-solution__group-item-title">
                  <a
                    href="#"
                    >SCHÖNOX® FLOORLASTIC EXTRA</a
                  >
                </div>
                <div class="b-solution__group-item-desc">
                  Клей для эластичных виниловых напольных покрытий
                </div>
              </div>
            </div>
            <div class="b-solution__group-item">
              <div class="b-solution__group-item-img">
                <a
                  href="#"
                >
                  <img
                    src="upload/iblock/f2c/f2c76e41910ba2de830cae28949359d9.jpg"
                    alt=""
                  />
                </a>
              </div>
              <div class="b-solution__group-item-text">
                <div class="b-solution__group-item-title">
                  <a
                    href="#"
                    >SCHÖNOX® MULTIFIX</a
                  >
                </div>
                <div class="b-solution__group-item-desc">
                  Клей для многоразовой фиксации гибких напольных покрытий<br />
                </div>
              </div>
            </div>
            <div class="b-solution__group-item">
              <div class="b-solution__group-item-img">
                <a
                  href="#"
                >
                  <img
                    src="upload/iblock/27d/27dae227db0ac811e361b338633cba30.jpg"
                    alt=""
                  />
                </a>
              </div>
              <div class="b-solution__group-item-text">
                <div class="b-solution__group-item-title">
                  <a
                    href="#"
                    >SCHÖNOX® UNITECH</a
                  >
                </div>
                <div class="b-solution__group-item-desc">
                  Клей для гибких напольных ПВХ покрытий
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="b-solution__group">
          <div class="b-solution__group-title" data-id="5">
            <div class="b-solution__group-key">5</div>
            -
            <div class="b-solution__group-name">Клей для деревянных полов</div>
          </div>
          <div class="b-solution__group-desc">Укладка паркета</div>

          <div class="b-solution__group-items">
            <div class="b-solution__group-item">
              <div class="b-solution__group-item-img">
                <a
                  href="#"
                >
                  <img
                    src="upload/iblock/d8d/d8ddc2a9ddf089acd24f1c895f58d368.png"
                    alt=""
                  />
                </a>
              </div>
              <div class="b-solution__group-item-text">
                <div class="b-solution__group-item-title">
                  <a
                    href="#"
                    >SikaBond®-52 Parquet</a
                  >
                </div>
                <div class="b-solution__group-item-desc">
                  Эластичный полиуретановый клей для деревянных полов для
                  сплошного и кардонного метода приклеивания. Используется в
                  системе Sika® AcouBond®
                </div>
              </div>
            </div>
            <div class="b-solution__group-item">
              <div class="b-solution__group-item-img">
                <a
                  href="#"
                >
                  <img
                    src="upload/iblock/197/1975c0a5ea33dc872f884632add3b477.jpg"
                    alt=""
                  />
                </a>
              </div>
              <div class="b-solution__group-item-text">
                <div class="b-solution__group-item-title">
                  <a
                    href="#"
                    >SikaBond®-54 Parquet</a
                  >
                </div>
                <div class="b-solution__group-item-desc">
                  Эластичный полиуретановый клей для деревянных полов
                </div>
              </div>
            </div>
            <div class="b-solution__group-item">
              <div class="b-solution__group-item-img">
                <a href="#">
                  <img
                    src="upload/iblock/44b/44b98a2f31db6dc8011cb4366a3ae0cd.jpg"
                    alt=""
                  />
                </a>
              </div>
              <div class="b-solution__group-item-text">
                <div class="b-solution__group-item-title">
                  <a href="#"
                    >SikaBond®-PU 2K</a
                  >
                </div>
                <div class="b-solution__group-item-desc">
                  Жёстко-эластичный двухкомпонентный полиуретановый клей для
                  деревянных полов, фанеры и ОСБ
                </div>
              </div>
            </div>
            <div class="b-solution__group-item">
              <div class="b-solution__group-item-img">
                <a href="#">
                  <img
                    src="upload/iblock/71e/71e5cae6e3639f0123ff3aca33e33505.jpg"
                    alt=""
                  />
                </a>
              </div>
              <div class="b-solution__group-item-text">
                <div class="b-solution__group-item-title">
                  <a href="#"
                    >SikaBond® T-45</a
                  >
                </div>
                <div class="b-solution__group-item-desc">
                  Полуэластичный полиуретановый клей для сплошного приклеивания
                  деревянных полов
                </div>
              </div>
            </div>
            <div class="b-solution__group-item">
              <div class="b-solution__group-item-img">
                <a href="#">
                  <img
                    src="upload/iblock/931/9316f3f44ccc4d50ec7f3309e0ba3562.png"
                    alt=""
                  />
                </a>
              </div>
              <div class="b-solution__group-item-text">
                <div class="b-solution__group-item-title">
                  <a href="#"
                    >SikaBond®-151</a
                  >
                </div>
                <div class="b-solution__group-item-desc">
                  Эластичный силан-модифицированный клей для приклейки
                  деревянных полов сплошным методом
                </div>
              </div>
            </div>
            <div class="b-solution__group-item">
              <div class="b-solution__group-item-img">
                <a href="#">
                  <img
                    src="upload/iblock/961/9616e9b49929efa57eb215db86fcd118.png"
                    alt=""
                  />
                </a>
              </div>
              <div class="b-solution__group-item-text">
                <div class="b-solution__group-item-title">
                  <a href="#"
                    >SikaBond®-152</a
                  >
                </div>
                <div class="b-solution__group-item-desc">
                  Эластичный силан-модифицированный клей для приклеивания
                  деревянных полов сплошным и кардонным методом. Используется в
                  системе Sika® AcouBond®
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="b-solution__group">
          <div class="b-solution__group-title" data-id="6">
            <div class="b-solution__group-key">6</div>
            -
            <div class="b-solution__group-name">Монтажные клеи</div>
          </div>
          <div class="b-solution__group-desc">Приклеивание и ремонт</div>

          <div class="b-solution__group-items">
            <div class="b-solution__group-item">
              <div class="b-solution__group-item-img">
                <a
                  href="#"
                >
                  <img
                    src="upload/iblock/ef1/ef1fd365a872f521a2df995fd91595e3.png"
                    alt=""
                  />
                </a>
              </div>
              <div class="b-solution__group-item-text">
                <div class="b-solution__group-item-title">
                  <a
                    href="#"
                    >Sikaflex®-11FC+ (i-Сure)</a
                  >
                </div>
                <div class="b-solution__group-item-desc">
                  2 в 1. Универсальный цветной клей-герметик
                </div>
              </div>
            </div>
            <div class="b-solution__group-item">
              <div class="b-solution__group-item-img">
                <a
                  href="#"
                >
                  <img
                    src="upload/iblock/243/2435bd59a34f1ce8b050977bdc46673a.png"
                    alt=""
                  />
                </a>
              </div>
              <div class="b-solution__group-item-text">
                <div class="b-solution__group-item-title">
                  <a
                    href="#"
                    >Sikaflex® Crystal Clear</a
                  >
                </div>
                <div class="b-solution__group-item-desc">
                  100&#37; прозрачный клей
                </div>
              </div>
            </div>
            <div class="b-solution__group-item">
              <div class="b-solution__group-item-img">
                <a
                  href="#"
                >
                  <img
                    src="upload/iblock/ecc/ecc5e6c7eda8bf109eb918ad902428ee.png"
                    alt=""
                  />
                </a>
              </div>
              <div class="b-solution__group-item-text">
                <div class="b-solution__group-item-title">
                  <a
                    href="#"
                    >SikaBond®-114 Grip Tight</a
                  >
                </div>
                <div class="b-solution__group-item-desc">
                  Клей для фиксации декоративных элементов
                </div>
              </div>
            </div>
            <div class="b-solution__group-item">
              <div class="b-solution__group-item-img">
                <a
                  href="#"
                >
                  <img
                    src="upload/iblock/3c9/3c932f03b6e79d3e68a6110ecd373e45.png"
                    alt=""
                  />
                </a>
              </div>
              <div class="b-solution__group-item-text">
                <div class="b-solution__group-item-title">
                  <a
                    href="#"
                    >SikaBond®-115 Strong Fix</a
                  >
                </div>
                <div class="b-solution__group-item-desc">
                  Высокопрочный акриловый клей
                </div>
              </div>
            </div>
            <div class="b-solution__group-item">
              <div class="b-solution__group-item-img">
                <a
                  href="#"
                >
                  <img
                    src="upload/iblock/c30/c304de710bd7f0a8421c727600ce40f6.png"
                    alt=""
                  />
                </a>
              </div>
              <div class="b-solution__group-item-text">
                <div class="b-solution__group-item-title">
                  <a
                    href="#"
                    >Sikaflex®-118 Extreme Grab</a
                  >
                </div>
                <div class="b-solution__group-item-desc">
                  Клей для фиксации тяжёлых элементов
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <p><a href="#"></a></p>
  </div>
</template>

<script>
export default {
    data() {
    return {
      breadcrumbs: [
        {
          label: "Главная",
          to: { name: "main" },
        },
        {
          label: "Решения для дома",
          to: { name: "solutions" },
        },
        {
          label: "Жилые помещения",
        },
      ],
    };
  },
};
</script>

<style lang="scss"></style>
